import React, { ReactNode } from 'react';

interface SkeletonWrapperProps {
    copies?: number;
    children: ReactNode;
}

const SkeletonWrapper: React.FunctionComponent<SkeletonWrapperProps> = ({ copies = 3, children }) => {
    return <>{[...Array(copies)].map(() => children)}</>;
};

export default SkeletonWrapper;
